import { render, staticRenderFns } from "./yue.vue?vue&type=template&id=011873b0&"
import script from "./yue.vue?vue&type=script&lang=js&"
export * from "./yue.vue?vue&type=script&lang=js&"
import style0 from "./yue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports